import { render } from "./noticia.vue?vue&type=template&id=a9021040&scoped=true"
import script from "./noticia.vue?vue&type=script&lang=js"
export * from "./noticia.vue?vue&type=script&lang=js"

import "./noticia.vue?vue&type=style&index=0&id=a9021040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9021040"]])

export default __exports__